
import { combineReducers } from 'redux';
import {authReducer, otpverifyReducer, resendReducer, renewTokenReducer, verifyTokenReducer, acceptInvitationReducer, registerTenantReducer, verifyRegistrationReducer, checkTenantExistsReducer}from './authReducer'
import { commonReducer, createServiceReducer, deleteServiceReducer, getServiceParamsReducer, getServiceReducer, getServiceViewReducer, sendemailReducer, serviceToggleReducer } from './commonReducer';
import { 
    getProfileReducer, roleDataReducer, 
    updateProfileImageReducer, updateProfileReducer, userCreateReducer, 
    userListReducer, userUpdateReducer, userViewReducer, getTermsByTypeReducer } from './userReducer';
import { createCategoryReducer, deleteCateoryReducer, getCategoryParamsReducer, getCategoryReducer, toggleCategoryReducer, viewCategoryReducer } from './categoryReducer';
import { createVehicleReducer, deleteVehicleReducer, getVehicleParamsReducer, getVehicleReducer, toggleVehicleReducer, vehicleViewReducer, uploadVehicleReducer } from './vehicleReducer';
import { createEnrollmentReducer, deleteEnrollmentReducer, exportEnrollmentReducer, getEnrollmentParamsReducer, getEnrollmentReducer, getEnrollmentViewReducer, toggleEnrollmentReducer, assignApplicationReducer } from './enrollmentReducer';
import { createBatchReducer, deleteBatchReducer, getAvailableStudentsReducer, getAvailableUsersReducer, getBatchParamsReducer, getBatchReducer, markAttendanceReducer, toggleBatchReducer, viewBatchReducer } from './batchReducer';
import { createExpenseReducer, deleteExpenseReducer, getExpenseParamsReducer, getExpenseReducer, getExpenseViewReducer } from './expenseReducer';
import { createFeeReducer, deleteFeeReducer, getFeeParamsReducer, getFeeReducer, getFeeViewReducer, getStudentFeeSummaryReducer, getEnrollmentFeeHistoryReducer } from './feeReducer';
import { getQueryReducer, createQueryReducer, viewQueryReducer, deleteQueryReducer, addRemarksReducer } from './queryReducer';
import { getCommonReportsReducer, getRevenueReportReducer, getStudentReportReducer, getInstructorReportReducer } from './dashboardReducer';
import { getPreferenceReducer, getPreferenceByPhoneReducer, savePreferenceReducer } from './preferenceReducer';
import { deleteFilesReducer } from './commonReducer';
import { 
    getSubscriptionPlanReducer, createSubscriptionReducer, 
    subscriptionStatusReducer, orderStatusReducer, syncPlansReducer, 
    getAllPlansReducer, userSubscriptionStatusReducer
} from './subscriptionReducer';
import { getTenantListReducer, getHeaderTenantListReducer, saveTenantReducer, viewTenantReducer } from './tenantReducer';
import { switchTenantReducer, enableBranchesReducer, listBranchesReducer, createBranchReducer } from './branchReducer';


const rootReducer = combineReducers({
    authReducer, resendReducer, otpverifyReducer, 
    renewTokenReducer, commonReducer, roleDataReducer, 
    verifyTokenReducer, acceptInvitationReducer,createCategoryReducer,
    getCategoryParamsReducer,deleteCateoryReducer,toggleCategoryReducer,viewCategoryReducer,getServiceParamsReducer,
    getServiceViewReducer,createServiceReducer,serviceToggleReducer,deleteServiceReducer,
    
    //enrollment reducers
    getEnrollmentReducer, getEnrollmentParamsReducer, createEnrollmentReducer, 
    deleteEnrollmentReducer, getEnrollmentViewReducer, toggleEnrollmentReducer, exportEnrollmentReducer,
    assignApplicationReducer,
    
    //user reducers
    userCreateReducer, userListReducer, userUpdateReducer,
    userViewReducer, getServiceReducer, getCategoryReducer,
    // vehicle reducers
    getVehicleReducer, getVehicleParamsReducer, createVehicleReducer,
    deleteVehicleReducer, vehicleViewReducer, toggleVehicleReducer,
    uploadVehicleReducer,
    
    // batch reducers
    getBatchReducer, getBatchParamsReducer, createBatchReducer,
    deleteBatchReducer, toggleBatchReducer, viewBatchReducer,
    
    getProfileReducer, updateProfileReducer, updateProfileImageReducer,
    getAvailableUsersReducer,
    getAvailableStudentsReducer, markAttendanceReducer,
    getTermsByTypeReducer,
    
    // expense reducers
    getExpenseReducer, getExpenseParamsReducer, createExpenseReducer,
    deleteExpenseReducer, getExpenseViewReducer ,

    // fee reducers
    getFeeReducer, getFeeParamsReducer, createFeeReducer,
    deleteFeeReducer, getFeeViewReducer, getStudentFeeSummaryReducer,
    getEnrollmentFeeHistoryReducer,
 
    // query reducers
    getQueryReducer, createQueryReducer, viewQueryReducer, deleteQueryReducer, addRemarksReducer,
    
    //dashboard reducers
    getCommonReportsReducer, getRevenueReportReducer, getStudentReportReducer, getInstructorReportReducer,
   
    //common reducers
    getPreferenceReducer, getPreferenceByPhoneReducer, savePreferenceReducer,deleteFilesReducer,
    
    // subscription reducers
    getSubscriptionPlanReducer, createSubscriptionReducer,
    subscriptionStatusReducer, orderStatusReducer, syncPlansReducer, getAllPlansReducer,
    userSubscriptionStatusReducer,
   
    //tenant reducers
    registerTenantReducer, verifyRegistrationReducer, checkTenantExistsReducer,
    getTenantListReducer, getHeaderTenantListReducer, saveTenantReducer, viewTenantReducer, sendemailReducer,

    //tenant switch & branch reducers
    switchTenantReducer, enableBranchesReducer, listBranchesReducer, createBranchReducer

});

export default rootReducer;